import { IAgoraRTCClient, NetworkQuality as NetworkQualityStruct } from "agora-rtc-sdk-ng";
import Vue from "vue";
import { AgoraEvents } from "../enums/AgoraEvents";
import { AgoraNetworkQualityInterface } from "../interfaces/AgoraQualityCheckerInterface";
import { NetworkQuality } from "../types/NetworkQuality";

export class AgoraNetworkQuality implements AgoraNetworkQualityInterface {

    client: IAgoraRTCClient | null = null;

    downlinkNetworkQuality: NetworkQuality = 0;
    uplinkNetworkQuality: NetworkQuality = 0;
    remoteUsersQuality: { [uid: string]: NetworkQualityStruct } | undefined;

    subscribe(client: IAgoraRTCClient) {
        this.client = client;

        client.on(AgoraEvents.NetworkQuality, (stats) => {

            Vue.set(this, "downlinkNetworkQuality", stats.downlinkNetworkQuality);
            Vue.set(this, "uplinkNetworkQuality", stats.uplinkNetworkQuality);
            Vue.set(this, "remoteUsersQuality", this.client?.getRemoteNetworkQuality())

        })
    }

    unsubscribe() {
        this.client?.removeAllListeners(AgoraEvents.NetworkQuality);
    }

    static getAverageNetworkQuality(quality: NetworkQualityStruct) {

        const downlinkInRange = quality.downlinkNetworkQuality >= 1 && quality.downlinkNetworkQuality <= 5;
        const uplinkInRange = quality.uplinkNetworkQuality >= 1 && quality.uplinkNetworkQuality <= 5;

        if (downlinkInRange && uplinkInRange) {
            return Math.round((quality.downlinkNetworkQuality + quality.uplinkNetworkQuality) / 2)
        }
        else if (downlinkInRange) {
            return quality.downlinkNetworkQuality
        }
        else if (uplinkInRange) {
            return quality.uplinkNetworkQuality
        }
        else {
            return quality.downlinkNetworkQuality
        }
    }
}